import { useSettings } from "@/hooks/useSettings";

const FONT = { small: "15px", medium: "16px", large: "17px" };
const HEADING = { small: 0.9, medium: 1, large: 1.12 };
const BUTTON = { small: "42px", medium: "48px", large: "56px" };
const SPACING = { compact: "3rem", medium: "5rem", large: "7rem" };
const APPEARANCE = {
  dark: {},
  soft: { background: "#121420", card: "#1B1E2B" },
  graphite: { background: "#17191F", card: "#21242E" },
};

export default function ThemeApplicator() {
  const settings = useSettings();
  const d = settings.design || {};
  const ap = APPEARANCE[d.appearance] || {};
  const bg = ap.background || d.background || "#0A0B0E";
  const card = ap.card || d.card || "#141721";
  const accent = d.accent || "#D4AF37";
  const accentSoft = d.accent_soft || "#E5C378";
  const text = d.text || "#F3F4F6";
  const border = d.border || "#2A2E3A";
  const button = d.button || accent;
  const radius = d.radius || "0.75rem";
  const fontSize = FONT[d.font_preset] || "16px";
  const hs = HEADING[d.heading_preset] || 1;
  const btnH = BUTTON[d.button_size] || "48px";
  const sec = SPACING[d.section_spacing] || "5rem";

  const css = `
    :root { --tp-accent: ${accent}; --tp-accent-soft: ${accentSoft}; }
    html { font-size: ${fontSize}; }
    body { background-color: ${bg} !important; color: ${text}; }
    .card-lux { background: ${card} !important; border-color: ${border} !important; border-radius: ${radius} !important; }
    .btn-gold { background: linear-gradient(90deg, ${button}, ${accentSoft}) !important; min-height: ${btnH}; border-radius: ${radius} !important; }
    .btn-ghost { min-height: ${btnH}; border-radius: ${radius} !important; }
    .gold-text { background: linear-gradient(120deg, ${accent}, ${accentSoft}); -webkit-background-clip: text; background-clip: text; color: transparent; }
    [class*="text-[#D4AF37]"] { color: ${accent} !important; }
    [class*="text-[#E5C378]"] { color: ${accentSoft} !important; }
    [class*="border-[#D4AF37]"] { border-color: ${accent} !important; }
    [class~="bg-[#D4AF37]"] { background-color: ${accent} !important; }
    h1 { font-size: calc(2.25rem * ${hs}) !important; }
    @media (min-width: 640px) { h1 { font-size: calc(3rem * ${hs}) !important; } }
    @media (min-width: 1024px) { h1 { font-size: calc(3.75rem * ${hs}) !important; } }
    section:not([class*="pt-24"]):not([class*="pt-28"]) { padding-top: ${sec}; padding-bottom: ${sec}; }
  `;

  return <style data-testid="theme-overrides">{css}</style>;
}
